import $ from 'jquery';

import serverStorage from "./modules/server-storage";
import session from "./modules/session";
import coupon from "./modules/coupon";
import fujisanReader from "./modules/fujisan-reader";
import loginWithToken from "./modules/login-with-token";

import "../css/style.scss"

// FMSオブジェクトを作る
window.FMS = {
  serverStorage,
  session,
  coupon,
  fujisanReader,
  loginWithToken,
}
